module.exports = __webpack_public_path__ + "static/media/content.4920610d.png";